export default __webpack_public_path__ + "static/media/nt-05.8d595cd2.jpg";